import React, { createContext, useState, useEffect, useContext } from 'react';
import NSCSSO from "../services/NSCSSO";
import storageService from "../utils/StorageService";

const REDIRECT_URL = process.env.REACT_APP_NSC_CALLBACK_URL;
const NSC_URL = process.env.REACT_APP_NSC_URL;

const OAuthContext = createContext(null);

export function OAuthProvider({ children }) {
    const [tokens, setTokens] = useState(() => {
        const savedTokens = localStorage.getItem('oauth_tokens');
        return savedTokens ? JSON.parse(savedTokens) : null;
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Check for authorization code in URL
        // const urlParams = new URLSearchParams(window.location.search);
        // const code = urlParams.get('code');
        // const state = urlParams.get('state');
        //
        // if (code && state) {
        //     // Verify state
        //     const savedState = localStorage.getItem('oauth_state');
        //     if (state !== savedState) {
        //         setError('Invalid state parameter');
        //         setLoading(false);
        //         return;
        //     }
        //
        //     // Exchange code for tokens
        //     exchangeCodeForTokens(code)
        //         .then(tokenData => {
        //             setTokens(tokenData);
        //             localStorage.setItem('oauth_tokens', JSON.stringify(tokenData));
        //
        //             // Clean up URL and local storage
        //             window.history.replaceState({}, document.title, window.location.pathname);
        //             localStorage.removeItem('oauth_state');
        //             localStorage.removeItem('code_verifier');
        //         })
        //         .catch(err => {
        //             setError(err.message);
        //         })
        //         .finally(() => {
        //             setLoading(false);
        //         });
        // } else {
        //     setLoading(false);
        // }
    }, []);

    // Functions for OAuth flow
    const login = () => {
        const codeVerifier = generateCodeVerifier();
        localStorage.setItem('code_verifier', codeVerifier);

        generateCodeChallenge(codeVerifier).then(codeChallenge => {
            const state = generateRandomString(16);
            localStorage.setItem('oauth_state', state);

            const queryParams = new URLSearchParams({
                client_id: process.env.REACT_APP_NSC_CLIENT_ID,
                redirect_uri: REDIRECT_URL,
                response_type: 'code',
                scope: 'openid profile email',
                state: state,
                code_challenge: codeChallenge,
                code_challenge_method: 'S256'
            });
            console.log('queryParams', queryParams.toString());

            const redirectUrl = `${NSC_URL}/api/oauth/authorize?${queryParams.toString()}`;

            console.log(redirectUrl);

            window.location.href = redirectUrl;
        });
    };

    const logout = () => {
        setTokens(null);
        localStorage.removeItem('oauth_tokens');
    };

    // const refreshTokens = async () => {
    //     if (!tokens?.refresh_token) return null;
    //
    //     try {
    //         const response = await fetch('https://sso.nationalscoliosisclinic.com/oauth/token', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 grant_type: 'refresh_token',
    //                 client_id: process.env.REACT_APP_NSC_CLIENT_ID,
    //                 client_secret: process.env.REACT_APP_NSC_CLIENT_SECRET,
    //                 refresh_token: tokens.refresh_token
    //             })
    //         });
    //
    //         if (!response.ok) throw new Error('Failed to refresh tokens');
    //
    //         const newTokens = await response.json();
    //         setTokens(newTokens);
    //         localStorage.setItem('oauth_tokens', JSON.stringify(newTokens));
    //         return newTokens;
    //     } catch (error) {
    //         setError(error.message);
    //         logout();
    //         return null;
    //     }
    // };

    // Helper for API requests
    // const fetchWithToken = async (url, options = {}) => {
    //     if (!tokens) throw new Error('No authentication tokens');
    //
    //     const requestOptions = {
    //         ...options,
    //         headers: {
    //             ...options.headers,
    //             Authorization: `Bearer ${tokens.access_token}`
    //         }
    //     };
    //
    //     let response = await fetch(url, requestOptions);
    //
    //     // Handle expired token
    //     if (response.status === 401) {
    //         const newTokens = await refreshTokens();
    //         if (!newTokens) throw new Error('Session expired');
    //
    //         // Retry with new token
    //         requestOptions.headers.Authorization = `Bearer ${newTokens.access_token}`;
    //         response = await fetch(url, requestOptions);
    //     }
    //
    //     return response;
    // };

    const getToken = async (code) => {
        const codeVerifier = storageService.getItem('code_verifier');

        const tokenRequest = {
            grant_type: 'authorization_code',
            client_id: process.env.REACT_APP_NSC_CLIENT_ID,
            client_secret: process.env.REACT_APP_NSC_CLIENT_SECRET, // Note: In a production SPA, this would be handled by your backend
            code: code,
            redirect_uri: REDIRECT_URL,
            code_verifier: codeVerifier
        };

        try {
            const response = await NSCSSO.getToken(tokenRequest);
            const { data, success, error } = response;
            console.log('response', response);
            if(!success) {
                console.error('Error fetching token:', error);
                return null;
            }
            // const response = await fetch('https://sso.nationalscoliosisclinic.com/api/oauth/token', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     },
            //     body: JSON.stringify(tokenRequest)
            // });

            // if (!response.ok) {
            //     return null;
            //     // throw new Error('Token exchange failed');
            // }
            //
            // const tokenData = await response.json();
            storageService.addItem('oauth_tokens_nsc', JSON.stringify(data));
            return data;
        } catch (error) {
            console.error('Error exchanging code for tokens:', error);
            throw error;
        }

    }

    const getProfileUsingToken = async () => {
        try {
            // const oauth_tokens_nsc = JSON.parse(storageService.getItem('oauth_tokens_nsc'));
            // console.log('oauth_tokens_nsc', oauth_tokens_nsc);

            // const tokens = getStoredTokens();

            // const response = await fetch('https://sso.nationalscoliosisclinic.com/api/users/me', {
            //     headers: {
            //         'Authorization': `Bearer ${oauth_tokens_nsc.access_token}`
            //     }
            // });

            // return response.json();
            const response = await NSCSSO.getProfile();
            console.log('response', response);
            const { data, success, error } = response;
            if(!success) {
                console.error('Error fetching token:', error);
                return null;
            }

            return data;
        } catch (e) {

        }
    }

    const value = {
        tokens,
        isAuthenticated: !!tokens,
        login,
        logout,
        // refreshTokens,
        // fetchWithToken,
        getToken,
        getProfileUsingToken,
        loading,
        error
    };

    return (
        <OAuthContext.Provider value={value}>
            {children}
        </OAuthContext.Provider>
    );
}

export const useAuth = () => useContext(OAuthContext);

// Helper functions
function generateRandomString(length) {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
}

function generateCodeVerifier() {
    return generateRandomString(32);
}

async function generateCodeChallenge(verifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(verifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    return base64UrlEncode(new Uint8Array(digest));
}

function base64UrlEncode(buffer) {
    const base64 = btoa(String.fromCharCode.apply(null, buffer));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

async function exchangeCodeForTokens(code) {
    const codeVerifier = localStorage.getItem('code_verifier');

    const response = await fetch(`${NSC_URL}/oauth/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            grant_type: 'authorization_code',
            client_id: process.env.REACT_APP_NSC_CLIENT_ID,
            client_secret: process.env.REACT_APP_NSC_CLIENT_SECRET, // Note: In a production SPA, this would be handled by your backend
            code: code,
            redirect_uri: window.location.origin,
            code_verifier: codeVerifier
        })
    });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error_description || 'Failed to exchange code for tokens');
    }

    return response.json();
}
